import React, { useCallback, useEffect, useRef, useState } from "react";
import uncodedIcon from "../../../common/assets/images/uncoded.png";
import unassignedIcon from "../../../common/assets/images/unassigned.png";
import overDueIcon from "../../../common/assets/images/overdue.png";
import inprogressIcon from "../../../common/assets/images/inprogress.png";
import backIcon from "../../../common/assets/images/back-icon.png";
import userIcon from "../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../common/assets/images/general-surgery-icon.png";
import workflowFilterIcon from "../../../common/assets/images/workflow-filter-icon.png";
import LdsRoller from "../../../utils/LdsRoller";
import { Box, Tooltip } from "@mui/material";
import closeIcon from "../../../common/assets/images/modal-close-icon.png";
import search_icon from "../../../common/assets/images/search-icon-new.png";
import urgentIcon from "../../../common/assets/images/Variation 2.png";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  faSort,
  faSortAmountUp,
  faSortAmountDown,
} from "@fortawesome/free-solid-svg-icons";
import RefershIcon from "../../../common/assets/images/reload.png";
import CoderFilterModal from "./CoderFilterModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faUserInjured,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  Table,
  Badge,
  Form,
  Pagination,
  Dropdown,
  Button,
  Card,
  Placeholder,
  Spinner,
} from "react-bootstrap";
import "../CoderView/CoderView.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatCalenderDate } from "../../CodingScreen/utils";
import { useDispatch, useSelector } from "react-redux";
import HealthInformationManagerAssignModal from "../HealthInsuranceManager/HealthInformationManagerAssignModal";
import {
  fetchCodersData,
  getCoderSidebarQueues,
  getCoderViewCards,
  fetchStatsData,
  fetchUserPreferences,
  updateUserAssginedFilters,
  resetCoderFilters,
  fetchCdqHistoryResponse,
} from "./redux/CoderScreenSlice";
import { debounce, filter } from "lodash";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  showAvailableAuditQueues,
  updateAuditorPage,
} from "../AuditorView/redux/AuditorViewSlicer";
import {
  resetDocumentViewerError,
  resetDocumentViewerLoadedData,
  resetEpisodeIdentifierTopassDocumentViewer,
} from "../../DocumentViewer/redux/DocumentViewerSlicer";
import { selectedEpisodeList } from "../../pages/EpisodeList/redux/EpisodeListSlicer";
// import { updateAuditorPage } from "../AuditorView/redux/AuditorViewSlicer";
import { useMediaQuery } from "@mui/material";
import CoderSideDrawer from "./mobile/CoderSideDrawer";
import InfiniteScroll from "../../../components/codercompanion/components/infinite-scroll";
import {
  setCoderFilterSearch,
  setEpisodeIdentiferFilterSearch,
  setHealthFundFilterContractSearch,
  setMRNFilterSearch,
  setPriorityFilterSearch,
  setProvisionalDrgFilterSearch,
  setQueueFilterSearch,
  setSpecialityFilterSearch,
  setStatusFilterSearch,
} from "../HealthInsuranceManager/redux/HealthInformationManagerSlicer";
import { setRawSearchQuery } from "../../CodeBook/redux/CodeBookSlicer";
import { handleResetSelectedDetails } from "../../CodeAssist/CodeSearch/redux/codeSearchSlice";
import ReactDatePickerIcon from "../../../utils/ReactDatePickerIcon";
import CdqResponseHistoryModal from "../CdqResponseHistoryModal/CdqResponseHistoryModal";
// import CdqResponseHistoryModal from "./CdqResponseHistoryModal";
const CoderView = () => {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const permissions = JSON.parse(sessionStorage.getItem("permissions")) || {};
  const loginUserID = JSON.parse(sessionStorage.getItem("userId")) || {};
  const hasCoderPremission =
    permissions["Code Workflow"] || permissions["Code Workflow HIM"];
  // declaration
  const dispatch = useDispatch();
  const dateFormat = "dd-MM-yyyy";
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const isSanEnvironment = codebooksanEnv || codebooksanprodEnv;
  const [searchType, setSearchType] = useState("episode"); // 'episode' | 'mrn'
  const [showOptions, setShowOptions] = useState(false);
  const [showCoderFilter, setShowCoderFilter] = useState(false);
  const [selectedDrgMap, setSelectedDrgMap] = useState({});
  const [drgAnchorEl, setDrgAnchorEl] = useState(null);
  const [activeDrgRow, setActiveDrgRow] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const [losOperator, setLosOperator] = useState("");
  const [losValue, setLosValue] = useState("");
  const [isLosEnabled, setIsLosEnabled] = useState(false);
  const [queueSelected, setQueueSelected] = useState(loginUserID);
  const [selectedQueueIndex, setSelectedQueueIndex] = useState(null);
  const getSelectedDrgIndex = (hcpLineId) => selectedDrgMap[hcpLineId] ?? 0;
 const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;


  const updateSelectedDrgIndex = (hcpLineId, index) => {
    setSelectedDrgMap((prev) => ({
      ...prev,
      [hcpLineId]: index,
    }));
  };

  const openDrgMenu = (event, hcpLineId) => {
    setDrgAnchorEl(event.currentTarget);
    setActiveDrgRow(hcpLineId);
  };

  const closeDrgMenu = () => {
    setDrgAnchorEl(null);
    setActiveDrgRow(null);
  };

  const navigate = useNavigate();
  const [showUserPreferenceModal, setShowUserPreferenceModal] = useState(false);
  const {
    data: queuesSidebarData,
    loading: queuesSidebarLoading,
    error: queuesSidebarError,
  } = useSelector((state) => state.coderscreenqueue.queueSidebarOptions);
  const {
    showAvailableAuditQueuesLoading,
    showAvailableAuditQueuesData,
    showAvailableAuditQueuesError,
  } = useSelector((state) => state.auditorView.showAvailableAuditQueues);
  const {
    data: coderCardsData,
    loading: coderCardsLoading,
    error: coderCardsError,
  } = useSelector((state) => state.coderscreenqueue.codercardOptions);
  const filtersPayload = useSelector(
    (state) => state.coderscreenqueue.coderFilter,
  );
  const [queues, setQueues] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [isQueueFetching, setIsQueueFetching] = useState(false);

  const containerRef = useRef(null);
  const pageRef = useRef(1);
  const queueLengthRef = useRef(0);

  const appliedFiltersRef = useRef(null);
  const appliedFilterBtnRef = useRef(null);
  // states
  const [episodesCurrentPage, setEpisodesCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [clickedEpisodeQueues, setClickedEpisodeQueues] = useState([]);
  const codersData = useSelector((state) => state.coderscreenqueue.codersData);
  const {} = useSelector((state) =>state.coderscreenqueue)
  const codersQueueData = useSelector(
    (state) => state.coderscreenqueue.coderQueuesData,
  );
  const queueFiltersData = useSelector(
    (state) => state.coderscreenqueue.queueFiltersData,
  );
  const statsLoading = useSelector(
    (state) => state.coderscreenqueue.loadingStatsData,
  );
  const coderStatsData = useSelector(
    (state) => state.coderscreenqueue.statsData,
  );
  const codersURNumberData = useSelector(
    (state) => state.coderscreenqueue.coderURNumberData,
  );
  const userPreferences = useSelector(
    (state) => state.coderscreenqueue.preferencesData,
  );
  const searchedCodersData = useSelector(
    (state) => state.coderscreenqueue.codersSearchedData,
  );
  const fetchedPages = useRef(new Set()); // tracks fetched pages
  const isFetching = useRef(false);
  const codersDataLoading = useSelector(
    (state) => state.coderscreenqueue.loadingCodersData,
  );
  const preferencesLoading = useSelector(
    (state) => state.coderscreenqueue.loadingPreferencesData,
  );
  const codersDataErrors = useSelector(
    (state) => state.coderscreenqueue.errorCodersData,
  );
  const cdqHistoryData = useSelector(
    (state) => state.coderscreenqueue.cdqHistoryData,
  );
  const loadingCdqHistoryData = useSelector(
    (state) => state.coderscreenqueue.loadingCdqHistoryData,
  );
  const errorCdqHistoryData = useSelector(
    (state) => state.coderscreenqueue.errorCdqHistoryData,
  );
  const debouncedCoderSearch = useRef();
  const [workflowHimsAssginModal, setWorkflowHimsAssginModal] = useState(false);
  const [episodesPerPage, setEpisodesPerPage] = useState(10);
  const [selectedHimEpisodes, setSelectedHimEpisodes] = useState([]);
  const [isAllEpisodesSelected, setIsAllEpisodesSelected] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [showFilterSection, setShowFilterSection] = useState(true);
  const [appliedFilterModal, setAppliedFilterModal] = useState(false);
  const [episodesData, setEpisodesData] = useState();
  const [specialitySearchValue, setSpecialitySearchValue] = useState("");
  const [currentQueueSearchValue, setCurrentQueueSearchValue] = useState("");
  const [codersSearchValue, setCodersSearchValue] = useState("");
  const [prioritySearchValue, setPrioritySearchValue] = useState("");
  const [statusSearchValue, setStatusSearchValue] = useState("");
  const [specialityPageNumbers, setspecialityPageNumber] = useState(1);
  const [coderSearchTerm, setCoderSearchTerm] = useState("");
  const [episodesToDisplay, setEpisodesToDisplay] = useState([]);
  const [showCdqModal, setShowCdqModal] = useState(false);
  const [selectedCdqRecord, setSelectedCdqRecord] = useState(null);
  const [cdqPageNumber, setCdqPageNumber] = useState(1);
  const CDQ_PAGE_SIZE = 4
  const handleViewCdqResponses = (episodeItem) => {
    setSelectedCdqRecord(episodeItem);
    setShowCdqModal(true);
    dispatch(
      fetchCdqHistoryResponse({
        hcp_line_id: episodeItem?.hcp_line_id,
        role:"coder",
        page_number: 1
      }),
    );
  };
 const handleCdqPageChange = (nextPage) => {
    if (nextPage < 1) return;
    setCdqPageNumber(nextPage);
    dispatch(
      fetchCdqHistoryResponse({
        hcp_line_id: selectedCdqRecord?.hcp_line_id,
         role:"coder",
        page_number: nextPage,
        // page_size: CDQ_PAGE_SIZE,
      }),
    );
  };

  const handleCloseCdqModal = () => {
    setShowCdqModal(false);
    setSelectedCdqRecord(null);
  };
  const pageSize = filtersPayload?.page_size || 10;
  const totalPages =
    typeof codersData?.episode_meta_data?.total_count === "number" &&
    typeof 10 === "number" &&
    10 > 0
      ? Math.max(
          1,
          Math.ceil(codersData?.episode_meta_data?.total_count / pageSize),
        )
      : 1;

  const queueTypes = codersData?.episodes?.flatMap((episode) =>
    episode.queue?.map((q) => q.queue_type),
  );

  const isLock = codersData?.episodes?.[0]?.is_locked ?? "";

  const isCoder = queueTypes?.includes("CODER");

  const getPatientTypeIcon = (patientType) => {
    const type = patientType?.toLowerCase();

    if (type?.includes("inpatient") || type === "in-patient") {
      return faBed;
    } else if (type?.includes("outpatient") || type === "out-patient") {
      return faUserInjured;
    }
    return faUser; // default icon
  };

  //clears the filters state when user leaves the coder workSpace
  useEffect(() => {
    return () => {
      dispatch(resetCoderFilters());
    };
  }, [dispatch]);
  const getPatientTypeColor = (patientType) => {
    const type = patientType?.toLowerCase();

    if (type?.includes("inpatient") || type === "in-patient") {
      return "#4CAF50";
    } else if (type?.includes("outpatient") || type === "out-patient") {
      return "#2196F3";
    }
    return "#757575";
  };
  const codingDashboardOptions =
    coderCardsData?.cards?.[0] &&
    Object.keys(coderCardsData.cards[0])
      .filter(
        (item) =>
          item === "urgent" || item === "for_review" || item === "overdue",
      )
      .map((item) => {
        if (item !== "")
          return {
            name:
              item === "urgent"
                ? "Urgent"
                : item === "overdue"
                  ? "Overdue"
                  : item === "for_review"
                    ? "For Review"
                    : "",
            count: coderCardsData.cards[0][item],
            icon:
              item === "urgent"
                ? urgentIcon
                : item === "overdue"
                  ? unassignedIcon
                  : item === "for_review"
                    ? inprogressIcon
                    : "",
            tooltipContent:
              item === "urgent"
                ? "You have 10 uncoded episodes awaiting coding"
                : item === "overdue"
                  ? "You have 10 unassigned episodes pending allocation"
                  : item === "for_review"
                    ? "You have 10 ongoing episodes in progress"
                    : "",
            backgroundColor:
              item === "urgent"
                ? "#FEF2F2"
                : item === "overdue"
                  ? "#FEFCE8"
                  : item === "for_review"
                    ? "#ECFDF5"
                    : "",
          };
      });

  const functionLocked = () => {
    return (
      <svg width="20" height="20" viewBox="0 0 24 24">
        <rect
          x="5"
          y="11"
          width="14"
          height="10"
          rx="2.5"
          stroke="#000"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M8 11V7.5a4.5 4.5 0 0 1 9 0V11"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    );
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...filtersPayload,
        page_number: pageNumber,
      };
      dispatch(fetchCodersData(payload)).then((res) => {
        setEpisodesToDisplay(res.payload.episodes);
      });
      dispatch(updateUserAssginedFilters(payload));
      dispatch(getCoderViewCards(payload));
      dispatch(fetchStatsData(payload));
      dispatch(getCoderSidebarQueues());
    }
  };

  const hanldeSelectQueueEpisodes = (type, data) => {
    if (type === "queue") {
      const isCodeEnhance = data?.queue_name === "Code Enhance";
      const payload = {
        ...filtersPayload,
        queue: [data?.queue_id],
        is_user_specific: false,
      };
      dispatch(updateUserAssginedFilters(payload));
      dispatch(fetchCodersData(payload));
      dispatch(getCoderViewCards(payload));
      dispatch(getCoderSidebarQueues());
      dispatch(fetchStatsData(payload));
      setCoderSearchTerm("");
    }
  };

  const handleDragStart = (e, item) => {
    e.dataTransfer.setData("application/json", JSON.stringify(item));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleClickCoder = () => {
    const payload = {
      ...filtersPayload,
      is_user_specific: true,
    };
    dispatch(fetchCodersData(payload));
    dispatch(getCoderViewCards(payload));
    dispatch(getCoderSidebarQueues());
    dispatch(updateUserAssginedFilters(payload));
    dispatch(fetchStatsData(payload));
    setCoderSearchTerm("");
  };

  const handleDrop = (e, queriesItem) => {
    e.preventDefault();
    const item = JSON.parse(e.dataTransfer.getData("application/json"));
    setWorkflowHimsAssginModal(true);
    const selectedEpisodeToTransfer = {
      ...item,
      speciality: queriesItem.queue_name,
    };
    setSelectedRecord(selectedEpisodeToTransfer);
  };

  const keysToRemove = ["page_number"];
  const newObj = { ...filtersPayload };
  keysToRemove.forEach((key) => {
    delete newObj[key];
  });

  const hasValue = Object.values(newObj).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true),
  );

  useEffect(() => {
    const coderQueues =
      codersData?.episodes?.flatMap((episode) =>
        episode?.queue?.filter((q) => q.queue_type === "CODER"),
      ) || [];

    // ✅ Auto-select if ONLY ONE queue
    if (coderQueues.length === 1) {
      setSelectedQueue(coderQueues[0]);
    }
  }, [codersData]);

  const handleModalClose = () => {
    setShowCoderFilter(false);
    dispatch(resetCoderFilters());
    dispatch(setEpisodeIdentiferFilterSearch(""));
    dispatch(setMRNFilterSearch(""));
    dispatch(setSpecialityFilterSearch(""));
    dispatch(setQueueFilterSearch(""));
    dispatch(setCoderFilterSearch(""));
    dispatch(setPriorityFilterSearch(""));
    dispatch(setStatusFilterSearch(""));
    dispatch(setHealthFundFilterContractSearch(""));
    dispatch(setProvisionalDrgFilterSearch(""));
    setCoderSearchTerm("");
    const resetState = {
      separation_date_from: null,
      separation_date_to: null,
      admission_date_from: null,
      admission_date_to: null,
      speciality: [],
      queue: [],
      status: [],
      page_number: 1,
      priority: [],
      medical_record_number: [],
      episode_identifier: [],
      health_fund_contract: [],
      los: [],
      los_op: "",
      drg_code: [],
      is_user_specific: true,
      sort_by: [],
      sort_order: [],
    };
    dispatch(fetchCodersData(resetState));
    dispatch(getCoderViewCards(resetState));
    dispatch(fetchStatsData(resetState));
    dispatch(getCoderSidebarQueues());
  };

  useEffect(() => {
    if (!clickedEpisodeQueues?.length) return;
    if (selectedQueue) return; // Don't override if already selected

    // Separate queues into categories
    const assignedQueues = clickedEpisodeQueues.filter(
      (q) =>
        "assigned_user_id" in q &&
        q?.queue_id !== null &&
        q?.queue_name?.trim(),
    );

    const cdqReviewQueues = clickedEpisodeQueues.filter(
      (q) =>
        "assigned_user_id" in q &&
        q?.queue_id === null &&
        !q?.queue_name?.trim(),
    );

    const availableQueues = clickedEpisodeQueues.filter(
      (q) => !("assigned_user_id" in q),
    );

    // Auto-select based on priority: assigned > cdq > available
    let queueToSelect = null;
    let indexToSelect = null;

    if (assignedQueues.length === 1) {
      // Only one assigned queue - select it
      queueToSelect = assignedQueues[0];
      indexToSelect = clickedEpisodeQueues.indexOf(queueToSelect);
    } else if (cdqReviewQueues.length === 1 && assignedQueues.length === 0) {
      // Only one CDQ review queue and no assigned queues - select it
      queueToSelect = cdqReviewQueues[0];
      indexToSelect = clickedEpisodeQueues.indexOf(queueToSelect);
    } else if (
      availableQueues.length === 1 &&
      assignedQueues.length === 0 &&
      cdqReviewQueues.length === 0
    ) {
      // Only one available queue and no assigned or CDQ queues - select it
      queueToSelect = availableQueues[0];
      indexToSelect = clickedEpisodeQueues.indexOf(queueToSelect);
    }

    // If we found a queue to select, set it
    if (queueToSelect && indexToSelect !== null) {
      setSelectedQueue(queueToSelect);
      setSelectedQueueIndex(indexToSelect);
      setQueueSelected(queueToSelect?.assigned_user_id || loginUserID);
    }
  }, [clickedEpisodeQueues, selectedQueue, loginUserID]);

  useEffect(() => {
    dispatch(fetchCodersData(filtersPayload));
    dispatch(getCoderViewCards(filtersPayload));
    dispatch(getCoderSidebarQueues());
    dispatch(fetchStatsData(filtersPayload));
  }, [dispatch]);

  const totalEpisodesObj = coderStatsData?.stats?.find(
    (item) => item.total_number_of_episodes !== undefined,
  );
  const totalNumberOfEpisodes = totalEpisodesObj?.total_number_of_episodes;
  const weightObj = coderStatsData?.stats?.find(
    (item) => item?.total_weight !== undefined,
  );
  const totalEpisodesWeight = weightObj?.total_weight ?? 0;

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
    setShowOptions(false);

    dispatch(
      updateUserAssginedFilters({
        ...filtersPayload,
        episode_identifier: [],
        medical_record_number: [],
        page_number: 1,
        speciality: [],
        status: [],
        speciality: [],
        status: [],
      }),
    );
  };
  const debounceSearchHandler = useCallback(
    debounce((payload) => {
      dispatch(updateUserAssginedFilters(payload));
      dispatch(fetchCodersData(payload)).then((res) => {
        setEpisodesToDisplay(res?.payload?.episodes || []);
      });
      dispatch(fetchStatsData(payload));
      dispatch(getCoderViewCards(payload));
      dispatch(getCoderSidebarQueues());
    }, 1000),
    [],
  );

  const handleCoderEpisodesSearch = (e) => {
    const value = e.target.value;
    setCoderSearchTerm(value);

    // ✅ Safe formatter
    const formatArray = (val) => {
      if (typeof val !== "string") return null;
      const trimmed = val.trim();
      return trimmed ? trimmed : null;
    };

    const formattedValue = formatArray(value);

    // 🔴 RESET CASE (empty input)
    if (!formattedValue) {
      debounceSearchHandler.cancel();

      const resetPayload = {
        ...filtersPayload,
        page_number: 1,
        episode_identifier: [],
        medical_record_number: [],
        speciality: [],
        status: [],
        is_global_search: false,
      };

      dispatch(updateUserAssginedFilters(resetPayload));

      setTimeout(() => {
        dispatch(fetchCodersData(resetPayload)).then((res) => {
          setEpisodesToDisplay(res?.payload?.episodes || []);
        });
      }, 0);

      dispatch(fetchStatsData(resetPayload));
      dispatch(getCoderViewCards(resetPayload));
      dispatch(getCoderSidebarQueues());

      return;
    }

    // ✅ BASE PAYLOAD
    const payload = {
      ...filtersPayload,
      page_number: 1,
      episode_identifier: [],
      medical_record_number: [],
      speciality: [],
      status: [],
      is_global_search: !!formattedValue,
    };

    // ✅ APPLY BASED ON SEARCH TYPE
    if (searchType === "episode") {
      payload.episode_identifier = [formattedValue];
      payload.is_global_search = true;
    }

    if (searchType === "mrn") {
      payload.medical_record_number = [formattedValue];
      payload.is_global_search = true;
    }

    if (searchType === "speciality") {
      payload.speciality = [formattedValue];
    }

    if (searchType === "status") {
      payload.status = [formattedValue];
    }

    setShowOptions(false);

    // 🔥 IMPORTANT: use formattedValue here (this was your bug)
    debounceSearchHandler(payload);
  };

  const checkPermissionAndNavigate = (selectedRecord) => {
    // ✅ Get CODER queues from THIS SPECIFIC episode
    const episodeCoderQueues =
      selectedRecord?.queue?.filter(
        (q) =>
          q.queue_type === "CODER" ||
          q.queue_type === "AUDIT" ||
          q.queue_type === "CODINGSUPPORT",
      ) || [];

    // ✅ If episode has exactly one CODER queue, auto-select it
    if (episodeCoderQueues.length === 1) {
      setSelectedQueue(episodeCoderQueues[0]);
    }

    const updatedRecord = {
      ...selectedRecord,
      episode_identifier: selectedRecord.episode_identifier,
    };
    sessionStorage.setItem("filters", JSON.stringify(filtersPayload));
    sessionStorage.setItem("last_hcp_line_id", updatedRecord?.hcp_line_id);
    const payload = {
      hcp_line_id: updatedRecord?.hcp_line_id,
      screen_type: "coder",
    };
    dispatch(showAvailableAuditQueues(payload)).then((res) => {
      if (res?.payload) {
        const allQueues = [
          ...(res.payload.queues || []),
          ...(res.payload.queues_user || []),
        ];
        setSelectedQueueIndex(null);
        setSelectedQueue(null);
        setClickedEpisodeQueues(allQueues);
        if (allQueues.length > 0) {
          // Separate queues into categories
          const assignedQueues = allQueues.filter(
            (q) =>
              "assigned_user_id" in q &&
              q?.queue_id !== null &&
              q?.queue_name?.trim(),
          );

          const cdqReviewQueues = allQueues.filter(
            (q) =>
              "assigned_user_id" in q &&
              q?.queue_id === null &&
              !q?.queue_name?.trim(),
          );

          const availableQueues = allQueues.filter(
            (q) => !("assigned_user_id" in q),
          );

          // Auto-select based on priority: assigned > cdq > available
          let queueToSelect = null;
          let indexToSelect = null;

          if (assignedQueues.length === 1) {
            // Only one assigned queue - select it
            queueToSelect = assignedQueues[0];
            indexToSelect = allQueues.indexOf(queueToSelect);
          } else if (
            cdqReviewQueues.length === 1 &&
            assignedQueues.length === 0
          ) {
            // Only one CDQ review queue and no assigned queues - select it
            queueToSelect = cdqReviewQueues[0];
            indexToSelect = allQueues.indexOf(queueToSelect);
          } else if (
            availableQueues.length === 1 &&
            assignedQueues.length === 0 &&
            cdqReviewQueues.length === 0
          ) {
            // Only one available queue and no assigned or CDQ queues - select it
            queueToSelect = availableQueues[0];
            indexToSelect = allQueues.indexOf(queueToSelect);
          } else if (assignedQueues.length > 0) {
            // Multiple assigned queues - select first
            queueToSelect = assignedQueues[0];
            indexToSelect = allQueues.indexOf(queueToSelect);
          } else if (cdqReviewQueues.length > 0) {
            // Multiple CDQ queues - select first
            queueToSelect = cdqReviewQueues[0];
            indexToSelect = allQueues.indexOf(queueToSelect);
          } else if (availableQueues.length > 0) {
            // Multiple available queues - select first
            queueToSelect = availableQueues[0];
            indexToSelect = allQueues.indexOf(queueToSelect);
          }

          if (queueToSelect && indexToSelect !== null) {
            setSelectedQueue(queueToSelect);
            setSelectedQueueIndex(indexToSelect);
            setQueueSelected(queueToSelect?.assigned_user_id || loginUserID);
          } else {
            setSelectedQueue(allQueues[0]);
          }
        }
      }
    });
    dispatch(resetEpisodeIdentifierTopassDocumentViewer());
    sessionStorage.setItem("currentPage", "coderview");
    dispatch(resetDocumentViewerLoadedData());
    dispatch(selectedEpisodeList(updatedRecord));
    dispatch(resetDocumentViewerError());
    dispatch(fetchUserPreferences()).then((res) => {
      const preferences = res.payload;

      if (
        preferences["Code Accelerate"] !== false ||
        preferences["Code Assist"] !== false
      ) {
        setShowUserPreferenceModal(true);
      } else if (episodeCoderQueues.length === 0) {
        if (preferences["Code Accelerate"]) {
          navigate("/coder", {
            state: {
              from: "coder",
              queue_id: null,
              queue_type: null,
            },
          });
        } else if (preferences["Code Assist"]) {
          navigate("/Code-Assist", {
            state: {
              from: "coder",
              queue_id: null,
              queue_type: null,
            },
          });
        } else {
          toast.error("You are not subscribed to any of the coding modules");
        }
      }
      // ✅ If episode has multiple queues, show modal for selection
      else if (episodeCoderQueues.length > 1) {
        setShowUserPreferenceModal(true);
      }
      // ✅ If episode has single queue and user has single module, navigate directly
      else {
        const queueToUse = episodeCoderQueues[0];

        if (preferences["Code Accelerate"]) {
          navigate("/coder", {
            state: {
              from: "coder",
              queue_id: queueToUse?.queue_id,
              queue_type: queueToUse?.queue_type,
            },
          });
        } else if (preferences["Code Assist"]) {
          navigate("/Code-Assist", {
            state: {
              from: "coder",
              queue_id: queueToUse?.queue_id,
              queue_type: queueToUse?.queue_type,
            },
          });
        } else {
          toast.error("You are not subscribed to any of the coding modules");
        }
      }
    });
  };
  const handleQueueSelect = (queue, index) => {
    setSelectedQueue(queue);
    setSelectedQueueIndex(index);
    setQueueSelected(queue?.assigned_user_id || loginUserID);
  };

  const navigateToDesiredPage = (type) => {
    // ✅ Allow navigation even without queues
    let queueToUse = null;
    const selectedQueueData =
      clickedEpisodeQueues.find((q) => q.line_assignment_id) ||
      clickedEpisodeQueues[0];
    // ✅ Only require queue selection if episode has multiple queues
    if (clickedEpisodeQueues.length > 1 && !selectedQueue) {
      toast.error("Please select a queue before proceeding");
      return;
    }

    // ✅ Get the queue to use
    if (clickedEpisodeQueues.length === 1) {
      queueToUse = clickedEpisodeQueues[0];
    } else if (clickedEpisodeQueues.length > 1) {
      if (!selectedQueue) {
        toast.error("Please select a queue before proceeding");
        return;
      }
      queueToUse = selectedQueue;
    }
    const isLockedKey = selectedRecord?.is_locked || isLock;
    dispatch(setRawSearchQuery(""));
    dispatch(handleResetSelectedDetails());
    if (type === "accelerate") {
      navigate("/coder", {
        state: {
          from: "coder",
          isLockedKey,
          queue_id: queueToUse?.queue_id || null,
          queue_type: queueToUse?.queue_type || null,
          line_assignment_id: queueToUse?.line_assignment_id || null,
        },
      });
      sessionStorage.setItem(
        "lineAssignmentId",
        queueToUse?.line_assignment_id || null,
      );
    } else if (type === "assist") {
      navigate("/Code-Assist", {
        state: {
          from: "coder",
          isLockedKey,
          queue_id: queueToUse?.queue_id || null,
          queue_type: queueToUse?.queue_type || null,
          line_assignment_id: queueToUse?.line_assignment_id || null,
        },
      });
      sessionStorage.setItem(
        "lineAssignmentId",
        queueToUse?.line_assignment_id || null,
      );
    }

    sessionStorage.setItem("filters", JSON.stringify(filtersPayload));
    dispatch(updateAuditorPage(false));
    setShowUserPreferenceModal(false);
  };

  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  //   useEffect(() => {
  //   const coderQueues =
  //     codersData?.episodes?.flatMap((episode) =>
  //       episode?.queue?.filter((q) => q.queue_type === "CODER")
  //     ) || [];

  //   // ✅ Auto-select if ONLY ONE queue
  //   if (coderQueues.length === 1) {
  //     setSelectedQueue(coderQueues[0]);
  //   }
  // }, [codersData]);
  useEffect(() => {
    if (selectedQueue) return; // 🔒 do NOT override existing selection

    const coderQueues =
      codersData?.episodes?.flatMap((episode) =>
        episode?.queue
          ?.filter((q) => q.queue_type === "CODER")
          .map((q) => ({
            queue_id: q.queue_id,
            queue_type: q.queue_type,
            queue_name: q.queue_name,
          })),
      ) || [];

    // Auto-select ONLY when exactly one queue
    if (coderQueues.length === 1) {
      setSelectedQueue(coderQueues[0]);
    }
  }, [codersData, selectedQueue, coderSearchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        appliedFiltersRef.current &&
        !appliedFiltersRef.current.contains(event.target) &&
        appliedFilterBtnRef.current &&
        !appliedFilterBtnRef.current.contains(event.target)
      ) {
        setAppliedFilterModal(false);
      }
    };

    if (appliedFilterModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [appliedFilterModal]);
  const handleSort = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    let order = "asc";

    if (currentSortBy === columnKey && currentSortOrder === "asc") {
      order = "desc";
    }

    const updatedFilters = {
      ...filtersPayload,
      sort_by: [columnKey],
      sort_order: [order],
      page_number: 1,
    };

    dispatch(updateUserAssginedFilters(updatedFilters));
    dispatch(fetchCodersData(updatedFilters));
    dispatch(getCoderViewCards(updatedFilters));
    dispatch(fetchStatsData(updatedFilters));
    dispatch(getCoderSidebarQueues());
  };
  const renderSortIcon = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return faSort; // neutral
    }

    return currentSortOrder === "asc" ? faSortAmountUp : faSortAmountDown;
  };
  const getSortTooltip = (columnKey) => {
    const currentSortBy = filtersPayload.sort_by?.[0];
    const currentSortOrder = filtersPayload.sort_order?.[0];

    if (currentSortBy !== columnKey) {
      return "Click to sort";
    }

    return currentSortOrder === "asc"
      ? "Sorted Ascending"
      : "Sorted Descending";
  };

  const formatYYYYMMDD = (d) =>
    d
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(d.getDate()).padStart(2, "0")}`
      : null;

  const PLACEHOLDERS = {
    separation_date_from: "Select Separation From",
    separation_date_to: "Select Separation Date To",
    admission_date_from: "Select Admission Date From",
    admission_date_to: "Select Admission Date To",
  };

  const assignedUsers = clickedEpisodeQueues.filter(
    (q) => "assigned_user_id" in q,
  );

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...filtersPayload,
      page_number: 1,
      page_size: Number(event.target.value),
    };

    dispatch(updateUserAssginedFilters(payload));
    dispatch(fetchCodersData(payload));
    dispatch(getCoderViewCards(payload));
    dispatch(fetchStatsData(payload));
    dispatch(getCoderSidebarQueues());
  };

  const coderViewStats = [
    {
      name: "Coded",
      name_color: "#349AD7",
      value: coderStatsData?.stats?.[0]?.total_number_of_episodes ?? 0,
      bg_color: "#bfdcff4d",
      borderColor: "#BFDBFE",
    },
    {
      name: "NWAU",
      name_color: "#16A34A",
      value: `${Number(coderStatsData?.stats?.[0]?.total_weight ?? 0).toFixed(2)}`,
      bg_color: "#bbf7d04d",
      borderColor: "#BBF7D0",
    },
    {
      name: "Revenue",
      name_color: "#9333EC",
      value: `$${coderStatsData?.stats?.[0]?.total_revenue ?? 0}`,
      bg_color: "#e9d5ff4d",
      borderColor: "#E9D5FF",
    },
    {
      name: "Total LOS",
      name_color: "#F28F0C",
      value: `${coderStatsData?.stats?.[0]?.total_los ?? 0 } ${coderStatsData?.stats?.[0]?.total_los > 1 ? "Days" : "Day"}`,
      bg_color: "#fed7aa4d",
      borderColor: "#FED7AA",
    },
    {
      name: "Average LOS",
      name_color: "#0D9488",
      value: `${Number(coderStatsData?.stats?.[0]?.average_los ?? 0).toFixed(1)} ${coderStatsData?.stats?.[0]?.average_los > 1 ? "Days" : "Day"}`,
      bg_color: "#99f6e44d",
      borderColor: "#99F6E4",
    },
  ];

  return (
    <div className="workflow-coder-container coder-screen">
      {!isMobile && (
        <div
          lg="3"
          sm="12"
          xs="12"
          md="12"
          className="left-coder-workflow-card"
        >
          {hasCoderPremission && (
            <div className="left-coder-workflow-card-header">
              <img
                src={backIcon}
                className="left-coder-workflow-card-icon"
                onClick={() => navigate("/Code-Workflow")}
              />
              <p className="left-coder-workflow-card-text">Back to Workflow</p>
            </div>
          )}
          <div className="left-coder-workflow-queues-card">
            <p className="left-coder-workflow-queues-card-header">Queues</p>
            <div
              className={
                queuesSidebarData?.queues?.length > 6
                  ? "coder-workflow-queues-container-queues"
                  : "coder-workflow-queues-container-no-queues"
              }
              ref={containerRef}
            >
              {queuesSidebarLoading ? (
                <div className="left-coder-workflow-queues-card-top-loading">
                  <div style={{ width: "100%", minHeight: "300px" }}>
                    <Placeholder animation="glow">
                      <Placeholder
                        xs={12}
                        className="coderview-queuePlaceholder"
                      />
                    </Placeholder>
                  </div>
                </div>
              ) : queuesSidebarError ? (
                <div className="left-coder-workflow-queues-error">
                  {" "}
                  No queues found{" "}
                </div>
              ) : (
                // Sort queues by priority (ascending - lower number = higher priority)
               [...(queuesSidebarData?.queues || [])]
                  .sort((a, b) => a.priority - b.priority)
                  .map((queriesItem) => (
                    <div
                      key={queriesItem.queue_id}
                      className="left-coder-workflow-queues-card-top"
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, queriesItem)}
                      onClick={() =>
                        hanldeSelectQueueEpisodes("queue", queriesItem)
                      }
                    >
                      <p className="left-coder-workflow-queues-card-icon">
                        <img
                          src={generalsurgeryIcon}
                          alt={queriesItem?.queue_name}
                        />
                      </p>

                      <p className="left-coder-workflow-queues-card-name">
                        <Tooltip title={queriesItem?.queue_name}>
                          <span>{queriesItem.queue_name}</span>
                        </Tooltip>
                      </p>

                      <p className="left-coder-workflow-queues-card-count">
                        ({queriesItem.number_of_episodes})
                      </p>
                    </div>
                  ))
              )}
            </div>
            <p className="left-coder-workflow-coders-card-header"> Coders </p>
            <div className="coder-workflow-queues-container-coders">
              {queuesSidebarLoading ? (
                <div className="left-coder-workflow-coders-card-top">
                  <div
                    className=""
                    style={{ width: "100%", minHeight: "100px" }}
                  >
                    <Placeholder animation="glow">
                      <Placeholder
                        xs={12}
                        className="coderview-codersPlaceholder"
                      />
                    </Placeholder>
                  </div>
                </div>
              ) : queuesSidebarError ? (
                <div className="left-coder-workflow-coders-error">
                  {" "}
                  No coders found{" "}
                </div>
              ) : (
                queuesSidebarData?.coders?.map((codersItem) => (
                  <div
                    style={{ cursor: "pointer" }}
                    className="left-coder-workflow-coders-card-top"
                    key={codersItem.user_id}
                    onDragOver={handleDragOver}
                    onClick={handleClickCoder}
                    onDrop={(e) => handleDrop(e, codersItem)}
                  >
                    <p className="left-coder-workflow-coders-card-icon">
                      <img src={userIcon} alt={codersItem.coder_name} />
                    </p>
                    <p className="left-coder-workflow-coders-card-name">
                      {`${codersItem.coder_name
                        .slice(0, 1)
                        .toUpperCase()}${codersItem.coder_name.slice(1)}`}
                    </p>
                    <p className="left-coder-workflow-coders-card-count">
                      {`(${codersItem.number_of_episodes})`}
                    </p>
                  </div>
                ))
              )}
            </div>
            <p className="left-coder-workflow-coders-card-header"> My Stats </p>
            {statsLoading ? (
              <Placeholder
                as={Card.Text}
                animation="glow"
                style={{ width: "100%" }}
              >
                <Placeholder xs={3} className="PlaceholderItem-stats" />{" "}
                <Placeholder xs={3} className="PlaceholderItem-stats" />{" "}
                <Placeholder xs={3} className="PlaceholderItem-stats" />{" "}
                <Placeholder xs={2} className="PlaceholderItem-stats" />
              </Placeholder>
            ) : (
              <>
                <div>
                  <div className="workflow-coderview-mystats-date-card">
                    <label className="workflow-him-filter-label">
                      Filter by Date Range
                    </label>
                    <DatePicker
                      selected={
                        filtersPayload.separation_date_from
                          ? new Date(filtersPayload.separation_date_from)
                          : null
                      }
                      startDate={
                        filtersPayload.separation_date_from
                          ? new Date(filtersPayload.separation_date_from)
                          : null
                      }
                      endDate={
                        filtersPayload.separation_date_to
                          ? new Date(filtersPayload.separation_date_to)
                          : null
                      }
                      selectsRange
                      className="workflow-coderview-mystats-date-picker"
                      placeholderText="Select Date Range"
                      isClearable
                      showMonthDropdown
                      showYearDropdown
                      onChange={(dates) => {
                        const [from, to] = dates;

                        // update selected dates in redux
                        dispatch(
                          updateUserAssginedFilters({
                            ...filtersPayload,
                            separation_date_from: from
                              ? formatYYYYMMDD(from)
                              : null,
                            separation_date_to: to ? formatYYYYMMDD(to) : null,
                          }),
                        );

                        // Call API only after both dates selected
                        if (from && to) {
                          const payload = {
                            ...filtersPayload,
                            separation_date_from: formatYYYYMMDD(from),
                            separation_date_to: formatYYYYMMDD(to),
                          };

                          dispatch(fetchStatsData(payload));
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="stats-top-wrapper">
                  {coderViewStats?.map((item) => (
                    <div
                      style={{
                        background: item?.bg_color,
                        border: `2px solid ${item?.borderColor}`,
                        padding: "5px",
                        borderRadius: "10px",
                        margin: "4px 0px",
                        minHeight: "65px",
                      }}
                    >
                      <p style={{ fontSize: "14px", color: item?.name_color }}>{item?.name}</p>
                      <p style={{ fontSize: "15px" }}>{item?.value}</p>
                    </div>
                  ))}
                  {/* <div className="stats-value-wrapper">
                  <label>Coded</label>
                  <span>{totalNumberOfEpisodes}</span>
                </div>
                {!isSanEnvironment && (
                  <div className="stats-value-wrapper">
                    <label>{codebookusaEnv ? "Weight" : "NWAU"}</label>
                    <span>
                      {totalEpisodesWeight === "null"
                        ? 0
                        : totalEpisodesWeight.toFixed(4)}
                    </span>
                  </div>
                )}
                <div className="stats-value-wrapper">
                  <label>$</label>
                  <span>
                    {Math.round(
                      totalEpisodesWeight *
                        (codebookusaEnv
                          ? 0.676 * 6624 * 1 + 0.324 * 6624
                          : 7258),
                    ).toLocaleString()}
                  </span>
                </div> */}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <div className="right-coder-workflow-card">
        {isMobile && (
          <div className="mobile-qc-header">
            <img
              src={backIcon}
              alt="back"
              className="mobile-qc-back-icon"
              onClick={() => navigate("/Code-Workflow")}
            />
            <span className="mobile-qc-back-text">Back to Workflow</span>
          </div>
        )}
        <div className="coder-dashboard">
          {coderCardsLoading ? (
            <Placeholder
              as={Card.Text}
              animation="glow"
              style={{ width: "100%", display: "flex", flexDirection: "row" }}
            >
              <Placeholder
                xs={3}
                className="PlaceholderItem"
                style={{ height: "85px" }}
              />{" "}
              <Placeholder
                xs={3}
                className="PlaceholderItem"
                style={{ height: "85px" }}
              />{" "}
              <Placeholder
                xs={3}
                className="PlaceholderItem"
                style={{ height: "85px" }}
              />{" "}
              <Placeholder
                xs={2}
                className="PlaceholderItem"
                style={{ height: "85px" }}
              />
            </Placeholder>
          ) : (
            codingDashboardOptions?.length > 0 &&
            codingDashboardOptions?.map((dashboardItem) => (
              <div
                key={dashboardItem.name}
                className="coder-dashboard-cards"
                style={{ backgroundColor: dashboardItem.backgroundColor }}
              >
                <div className="coder-dashboard-cards-top">
                  <p className="coder-dashboard-name">
                    {dashboardItem.name}
                  </p>
                  <p className="coder-dashboard-icon">
                    <img src={dashboardItem.icon} alt={dashboardItem.name} />
                  </p>
                </div>
                <p className="coder-dashboard-count">{dashboardItem.count}</p>
              </div>
            ))
          )}
        </div>
        {isMobile && (
          <div className="mobile-view-filter">
            <CoderSideDrawer
              handleDragOver={handleDragOver}
              handleDrop={handleDrop}
              hanldeSelectQueueEpisodes={hanldeSelectQueueEpisodes}
              healthInformationManagerData={{
                queues: queuesSidebarData || [],
                coders: codersData?.coders || [],
                stats: {
                  totalNumberOfEpisodes: totalNumberOfEpisodes || 0,
                  totalEpisodesWeight: totalEpisodesWeight || 0,
                },
              }}
            />
          </div>
        )}
        <div
          className="workflow-coder-table-container"
          style={{ overflowX: "auto" }}
        >
          <div className="workflow-coder-table-header">
            {/* LEFT: Selected / Total Episodes */}
            <div className="workflow-coder-selected-rows-count">
              <Badge className="workflow-coder-selected-rows-count-badge">
                {selectedHimEpisodes?.length > 0
                  ? `Selected Episodes: ${selectedHimEpisodes.length}`
                  : `Total Episodes: ${
                      codersData?.episode_meta_data?.total_count || 0
                    }`}
              </Badge>
            </div>

            {/* GAP */}
            <div className="workflow-coder-header-spacer" />

            {/* SEARCH */}
            <div className="coder-screen-search">
              <img src={search_icon} alt="search" />
              {searchType === "separation_date_from" ||
              searchType === "separation_date_to" ||
              searchType === "admission_date_from" ||
              searchType === "admission_date_to" ? (
                <ReactDatePickerIcon
                  selectedDate={
                    filtersPayload[searchType]
                      ? new Date(filtersPayload[searchType])
                      : null
                  }
                  onChange={(d) => {
                    const formattedDate = d ? formatYYYYMMDD(d) : null;

                    const payload = {
                      ...filtersPayload,
                      page_number: 1,
                      separation_date_from: null,
                      separation_date_to: null,
                      admission_date_from: null,
                      admission_date_to: null,
                      [searchType]: formattedDate,
                    };
                    dispatch(updateUserAssginedFilters(payload));
                    setTimeout(() => {
                      dispatch(fetchCodersData(payload)).then((res) => {
                        setEpisodesToDisplay(res?.payload?.episodes || []);
                      });
                    }, 0);

                    dispatch(fetchStatsData(payload));
                    dispatch(getCoderSidebarQueues());
                  }}
                  setShowOptions={setShowOptions}
                  placeholder={PLACEHOLDERS[searchType] || ""}
                  onFocus={() => {
                    setShowOptions(true);
                  }}
                  onMouseDown={() => setShowOptions(true)}
                />
              ) : (
                <input
                  type="text"
                  value={coderSearchTerm}
                  onChange={handleCoderEpisodesSearch}
                  placeholder={
                    {
                      episode: "Search by Episode ID",
                      mrn: "Search by MRN",
                      speciality: "Search by Speciality",
                      status: "Search by Status",
                    }[searchType] || ""
                  }
                  onFocus={() => setShowOptions(true)}
                  onBlur={() => setTimeout(() => setShowOptions(false), 150)}
                />
              )}

              {showOptions && (
                <div className="search-options-dropdown">
                  <div
                    className={`search-option ${searchType === "episode" ? "active" : ""}`}
                    onMouseDown={() => handleSearchTypeChange("episode")}
                  >
                    Search by Episode ID
                  </div>

                  <div
                    className={`search-option ${searchType === "mrn" ? "active" : ""}`}
                    onMouseDown={() => handleSearchTypeChange("mrn")}
                  >
                    Search by MRN
                  </div>
                </div>
              )}
            </div>

            {/* FILTER */}
            <span
              style={{ cursor: "pointer" }}
              onClick={() => setShowCoderFilter(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#1f1f1f"
              >
                <path d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"></path>
              </svg>
            </span>

            {/* REFRESH */}
            <div
              className="coder-refresh-btn"
              style={{ cursor: "pointer" }}
              onClick={() => {
                const refreshPayload = {
                  separation_date_from: null,
                  separation_date_to: null,
                  admission_date_from: null,
                  admission_date_to: null,
                  speciality: [],
                  queue: [],
                  status: [],
                  page_number: 1,
                  priority: [],
                  medical_record_number: [],
                  episode_identifier: [],
                  health_fund_contract: [],
                  los: [],
                  los_op: "",
                  drg_code: [],
                  is_user_specific: true,
                  sort_by: [],
                  sort_order: [],
                };
                setLosOperator("");
                setLosValue("");
                setCoderSearchTerm("");
                setLosOperator("");
                setLosValue("");
                setIsLosEnabled(false);
                dispatch(fetchCodersData(refreshPayload));
                dispatch(getCoderViewCards(refreshPayload));
                dispatch(fetchStatsData(refreshPayload));
                dispatch(getCoderSidebarQueues());
                dispatch(updateUserAssginedFilters(refreshPayload));
              }}
            >
              <img src={RefershIcon} alt="Refresh" />
            </div>
          </div>

          <div className="workflow-coder-table-body">
            <Table
              className="workflow-table-Hims"
              style={{ width: "100%" }}
            >
              <thead className="workflow-coder-table-thead">
                <tr className="workflow-coder-table-tr">
                  <th className="workflow-coder-table-th">
                    <span></span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("episode_identifier")}
                  >
                    <span>Episode Identifier</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip
                        title={getSortTooltip("episode_identifier")}
                        arrow
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("episode_identifier")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("medical_record_number")}
                  >
                    <span>MRN/UR</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip
                        title={getSortTooltip("medical_record_number")}
                        arrow
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("medical_record_number")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("admission_date")}
                  >
                    <span>Admission Date</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("admission_date")} arrow>
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("admission_date")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("separation_date")}
                  >
                    <span>Discharge Date</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("separation_date")} arrow>
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("separation_date")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("length_of_stay")}
                  >
                    <span>LOS</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("length_of_stay")} arrow>
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("length_of_stay")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("speciality")}
                  >
                    <span>Speciality/Unit</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("speciality")} arrow>
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("speciality")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("insurer_identifier")}
                  >
                    <span>Health Fund Contract</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip
                        title={getSortTooltip("insurer_identifier")}
                        arrow
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("insurer_identifier")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-auditor-table-th"
                    onClick={() => handleSort("drg_codes")}
                  >
                    <span>Provisional DRG</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("drg_codes")} arrow>
                        <span>
                          <FontAwesomeIcon icon={renderSortIcon("drg_codes")} />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-auditor-table-th"
                    onClick={() => handleSort("weight")}
                  >
                    <span>Provisional Account Revenue</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("weight")} arrow>
                        <span>
                          <FontAwesomeIcon icon={renderSortIcon("weight")} />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("queue")}
                  >
                    <span>Current Queue</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("queue")} arrow>
                        <span>
                          <FontAwesomeIcon icon={renderSortIcon("queue")} />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("queue_priority")}
                  >
                    <span>Priority</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("queue_priority")} arrow>
                        <span>
                          <FontAwesomeIcon
                            icon={renderSortIcon("queue_priority")}
                          />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                  <th
                    className="workflow-coder-table-th"
                    onClick={() => handleSort("status")}
                  >
                    <span>Status</span>
                    <span className="episodelist-sort-icon">
                      <Tooltip title={getSortTooltip("status")} arrow>
                        <span>
                          <FontAwesomeIcon icon={renderSortIcon("status")} />
                        </span>
                      </Tooltip>
                    </span>
                  </th>
                 {(codebookcoblhEnv||codebookdevEnv)&& <th className="workflow-coder-table-th">
                    <span>CDQ</span>
                  </th>}
                </tr>
              </thead>
              <tbody className="workflow-coder-table-body">
                {codersDataLoading ? (
                  <td colSpan="10">
                    <div className="workflow-coder-table-loader">
                      <LdsRoller />
                    </div>
                  </td>
                ) : codersDataErrors ? (
                  <td colSpan="10">
                    <div className="workflow-coder-table-error">
                      No data found
                    </div>
                  </td>
                ) : (coderSearchTerm?.length > 0
                    ? episodesToDisplay
                    : codersData?.episodes
                  )?.length === 0 ? (
                  <td colSpan="10">
                    <div className="workflow-coder-table-error">
                      No records found
                    </div>
                  </td>
                ) : coderSearchTerm?.length > 0 ? (
                  episodesToDisplay?.map((HimTableItem, index) => (
                    <tr
                      key={HimTableItem.episode_identifier}
                      className="workflow-coder-table-tr"
                      onClick={() =>
                        checkPermissionAndNavigate(HimTableItem)
                      }
                    >
                      <td className="workflow-him-table-td">
                        {HimTableItem.is_locked ? functionLocked() : " "}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem.episode_identifier}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem.medical_record_number}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem.admission_date}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem.separation_date}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem.length_of_stay}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem?.speciality
                          ? HimTableItem?.speciality
                          : "-"}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem?.health_fund_contract
                          ? HimTableItem.health_fund_contract
                          : "-"}
                      </td>
                      <td className="workflow-him-table-td">
                        {(() => {
                          const drgs = HimTableItem?.drg_code || [];
                          if (!drgs.length) return "-";

                          const defaultDrg =
                            drgs.find((drg) => drg.is_default) || drgs[0];

                          const remainingDrgs = drgs.filter(
                            (drg) => drg !== defaultDrg && drg.drg_code,
                          );

                          if (!drgs?.length) return "-";

                          const selectedIndex = getSelectedDrgIndex(
                            HimTableItem.hcp_line_id,
                          );
                          const selectedDrg = drgs[selectedIndex];

                          return (
                            <>
                              <Tooltip
                                title={
                                  <>
                                    <div>
                                      <b>Grouper Version:</b>{" "}
                                      {defaultDrg.grouper_version}
                                    </div>
                                    <div>
                                      <b>Weight:</b> {defaultDrg.weight}
                                    </div>
                                  </>
                                }
                                arrow
                              >
                                <span
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "2px",
                                  }}
                                  onClick={(e) =>
                                    openDrgMenu(e, HimTableItem.hcp_line_id)
                                  }
                                >
                                  {defaultDrg.drg_code}
                                  {drgs?.length > 1 && (
                                    <ArrowDropDownIcon fontSize="small" />
                                  )}
                                </span>
                              </Tooltip>

                              <Menu
                                anchorEl={drgAnchorEl}
                                open={
                                  Boolean(drgAnchorEl) &&
                                  activeDrgRow === HimTableItem.hcp_line_id
                                }
                                onClose={closeDrgMenu}
                              >
                                {remainingDrgs.map((drg, index) => (
                                  <Tooltip
                                    key={index}
                                    title={
                                      <>
                                        <div>
                                          <b>Version:</b> {drg.grouper_version}
                                        </div>
                                        <div>
                                          <b>Weight:</b> {drg.weight}
                                        </div>
                                      </>
                                    }
                                    placement="right"
                                    arrow
                                  >
                                    <MenuItem
                                      onClick={() => {
                                        updateSelectedDrgIndex(
                                          HimTableItem.hcp_line_id,
                                          index,
                                        );
                                        closeDrgMenu();
                                      }}
                                    >
                                      {drg.drg_code}
                                    </MenuItem>
                                  </Tooltip>
                                ))}
                              </Menu>
                            </>
                          );
                        })()}
                      </td>
                      <td>
                        {(() => {
                          const drgs = HimTableItem?.drg_code || [];
                          if (!drgs.length) return "-";

                          const defaultDrg =
                            drgs.find((drg) => drg.is_default) || drgs[0];
                          if (!drgs?.length) return "-";

                          return (
                            <>
                              <span>
                                ${" "}
                                {Math.round(
                                  defaultDrg.weight * 7258,
                                ).toLocaleString()}
                              </span>
                            </>
                          );
                        })()}
                      </td>
                      {/* <td className="workflow-him-table-td">
                      {!isNaN(Number(HimTableItem?.weight))
                        ? Number(HimTableItem.weight).toFixed(4)
                        : "-"}
                    </td> */}
                      {/* <td className="workflow-him-table-td">
                        {Number.isFinite(HimTableItem?.weight)
                          ? Math.round(
                              HimTableItem.weight * 7258
                            ).toLocaleString("en-IN")
                          : "-"}
                      </td> */}
                      {/* <td className="workflow-him-table-td">
                      <Badge className="workflow-him-current_queue">
                        <div>
                          <img
                            src={userIcon}
                            alt=""
                            height="15px"
                            width="15px"
                            className="me-2"
                          />
                        </div>
                        <div>{HimTableItem.queue[0].queue_name}</div>
                        <div></div>
                      </Badge>
                    </td> */}

                      {/* <td className="workflow-him-table-td">
                        {HimTableItem?.queue?.length > 0 ? (
                          <> */}
                      {/* <div>
                              <img
                                src={userIcon}
                                alt=""
                                height="15px"
                                width="15px"
                                className="me-2"
                              />
                            </div> */}
                      {/* <div>
                              {HimTableItem.queue
                                .filter(q => q.queue_name)
                                .map(q => q.queue_name)
                                .join(', ')}
                            </div>
                            </>
                        ) : " - "}
                    </td> */}

                      <td className="workflow-him-table-td">
                        {HimTableItem?.queue?.length > 0
                          ? (() => {
                              const queueNames = HimTableItem.queue
                                .filter((q) => q?.queue_name)
                                .map((q) => q.queue_name);

                              const MAX_ITEMS = 2; // how many to show before "..."
                              const visibleItems = queueNames.slice(
                                0,
                                MAX_ITEMS,
                              );
                              const hasMore = queueNames.length > MAX_ITEMS;

                              return (
                                <Tooltip
                                  title={
                                    <div style={{ padding: "4px 8px" }}>
                                      {queueNames.map((name, index) => (
                                        <div key={index}> {name}</div>
                                      ))}
                                    </div>
                                  }
                                  arrow
                                  placement="top"
                                >
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      maxWidth: "180px",
                                    }}
                                  >
                                    {visibleItems.map((name, index) => (
                                      <span key={index}>
                                        {name}
                                        {index < visibleItems.length - 1 &&
                                          ", "}
                                      </span>
                                    ))}
                                    {hasMore && " ..."}
                                  </div>
                                </Tooltip>
                              );
                            })()
                          : "-"}
                      </td>

                      <td className="workflow-him-table-td">
                        <Badge
                          className="workflow-him-priority"
                          ref={(el) => {
                            if (el) {
                              el.style.setProperty(
                                "background-color",
                                HimTableItem.priority === "URGENT"
                                  ? "#0000"
                                  : HimTableItem.priority === "HIGH"
                                    ? "#FEF6EE"
                                    : HimTableItem.priority === "LOW"
                                      ? "#F9FAFB"
                                      : HimTableItem.priority === "OVERDUE"
                                        ? "#FEFCE8"
                                        : "",
                                "important",
                              );
                              el.style.setProperty(
                                "border",
                                `1px solid ${
                                  HimTableItem.priority === "URGENT"
                                    ? "#000"
                                    : HimTableItem.priority === "HIGH"
                                      ? "#F9DBAF"
                                      : HimTableItem.priority === "LOW"
                                        ? "#EAECF0"
                                        : HimTableItem.priority === "OVERDUE"
                                          ? "#F9DBAF"
                                          : ""
                                }`,
                                "important",
                              );
                              el.style.setProperty(
                                "color",
                                `${
                                  HimTableItem.priority === "URGENT"
                                    ? "#C11574"
                                    : HimTableItem.priority === "HIGH"
                                      ? "#D28800"
                                      : HimTableItem.priority === "LOW"
                                        ? "#344054"
                                        : HimTableItem.priority === "OVERDUE"
                                          ? "#344054"
                                          : ""
                                }`,
                                "important",
                              );
                            }
                          }}
                          style={{
                            border: "1px solid #FCCEEE",
                            backgroundColor: HimTableItem.PriorityColor,
                          }}
                        >
                          {HimTableItem.priority}
                        </Badge>
                      </td>
                      <td className="workflow-auditor-table-td">
                        {Array.isArray(HimTableItem?.status) &&
                        HimTableItem.status.length > 0
                          ? (() => {
                              const list = HimTableItem.status.filter(
                                (s) => s?.status,
                              );
                              const topStatus = list?.filter(
                                (item) => item?.is_primary,
                              );
                              const statusText =
                                topStatus?.map((item) => item.status) ?? "-";
                              const hasMultiple = list.length > 1;

                              const getColor = (statusText) => {
                                const status = statusText[0];
                                switch (status) {
                                  case "Audit - AI processing complete - codes available for validation":
                                    return "#4CAF50";
                                  case "Audit - Audited":
                                    return "#2E7D32";
                                  case "Audit - Awaiting Audit":
                                  case "Awaiting Audit":
                                    return "#FFA726";
                                  case "Audit - Awaiting CDQ":
                                    return "#FFB300";
                                  case "Audit - CDQ For Review":
                                    return "#FB8C00";
                                  case "Audit - Coding Complete":
                                    return "#00897B";
                                  case "Audit - Locked by user":
                                    return "#757575";
                                  case "Audit - Missing Notes":
                                    return "#E53935";
                                  case "Audit - On Hold":
                                    return "#6A1B9A";
                                  case "Audit - Outstanding":
                                    return "#F44336";
                                  default:
                                    return "#344054";
                                }
                              };

                              return (
                                <Tooltip
                                  title={
                                    <div style={{ padding: "4px 8px" }}>
                                      {list.map((item, index) => (
                                        <div key={index}>{item.status}</div>
                                      ))}
                                    </div>
                                  }
                                  arrow
                                  placement="top"
                                >
                                  <Box
                                    sx={{
                                      position: "relative",
                                      width: "180px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {hasMultiple &&
                                      list.slice(1, 3).map((item, index) => (
                                        <Box
                                          key={index}
                                          sx={{
                                            position: "absolute",
                                            top: `${(index + 1) * 4}px`,
                                            left: `${(index + 1) * 4}px`,
                                            width: "100%",
                                            height: "34px",
                                            borderRadius: "6px",
                                            backgroundColor: "#E0E0E0",
                                            zIndex: index,
                                          }}
                                        />
                                      ))}

                                    <Box
                                      sx={{
                                        position: "relative",
                                        zIndex: 1,
                                        backgroundColor: "#FFF",
                                        color: getColor(statusText),
                                        border: "1px solid #D0D5DD",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        padding: "6px 8px",
                                        textAlign: "center",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      {statusText}
                                    </Box>

                                    {list.length > 3 && (
                                      <Box
                                        sx={{
                                          position: "absolute",
                                          bottom: "-6px",
                                          right: "-6px",
                                          background: "#344054",
                                          color: "#fff",
                                          fontSize: "10px",
                                          borderRadius: "10px",
                                          px: "5px",
                                          py: "1px",
                                        }}
                                      >
                                        +{list.length - 1}
                                      </Box>
                                    )}
                                  </Box>
                                </Tooltip>
                              );
                            })()
                          : "-"}
                      </td>
                      <td className="workflow-him-table-td">
                        {HimTableItem?.cdq_count > 0 ? (
                          <span
                            className="workflow-him-cdq-view"
                            style={{
                              color: "#175CD3",
                              fontWeight: 500,
                              fontSize: "13px",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              whiteSpace: "nowrap",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewCdqResponses(HimTableItem);
                            }}
                          >
                            View ({HimTableItem.cdq_count})
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : codersData?.episodes?.length > 0 ? (
                  codersData?.episodes?.map((HimTableItem, index) => {
                    const PRIORITY_STYLES = {
                      URGENT: {
                        bg: "#FDF2FA",
                        border: "#FCCEEE",
                        color: "#C11574",
                      },
                      HIGH: {
                        bg: "#FEF6EE",
                        border: "#F9DBAF",
                        color: "#D28800",
                      },
                      LOW: {
                        bg: "#F9FAFB",
                        border: "#EAECF0",
                        color: "#344054",
                      },
                      OVERDUE: {
                        bg: "#FEFCE8",
                        border: "#F9DBAF",
                        color: "#344054",
                      },
                      MEDIUM: {
                        bg: "#FEFCE8",
                        border: "#F9DBAF",
                        color: "#344054",
                      },
                    };
                    const activePriority = Array.isArray(HimTableItem?.priority)
                      ? HimTableItem.priority.find((p) => PRIORITY_STYLES[p]) ||
                        ""
                      : PRIORITY_STYLES[HimTableItem?.priority]
                        ? HimTableItem.priority
                        : "";
                    const styles = PRIORITY_STYLES[activePriority] || {};
                    return (
                      <tr
                        key={HimTableItem?.episode_identifier}
                        className="workflow-coder-table-tr"
                        onClick={() =>
                          checkPermissionAndNavigate(HimTableItem)
                        }
                      >
                        <td className="workflow-him-table-td">
                          {HimTableItem.is_locked ? functionLocked() : ""}
                        </td>
                        <td className="workflow-him-table-td">
                          {HimTableItem?.episode_identifier}
                        </td>
                        <td className="workflow-him-table-td">
                          {HimTableItem?.medical_record_number}
                        </td>
                        <td className="workflow-him-table-td">
                          {HimTableItem?.admission_date}
                        </td>
                        <td className="workflow-him-table-td">
                          {HimTableItem?.separation_date !== null
                            ? HimTableItem?.separation_date
                            : "-"}
                        </td>
                        <td className="workflow-him-table-td">
                          {HimTableItem?.length_of_stay}
                        </td>
                        <td className="workflow-him-table-td">
                          {HimTableItem?.speciality
                            ? HimTableItem?.speciality
                            : "-"}
                        </td>
                        <td className="workflow-him-table-td">
                          {HimTableItem?.health_fund_contract
                            ? HimTableItem.health_fund_contract
                            : "-"}
                        </td>
                        <td className="workflow-auditor-table-td">
                          {(() => {
                            const drgs = HimTableItem?.drg_code || [];
                            if (!drgs.length) return "-";

                            const defaultDrg =
                              drgs.find((drg) => drg.is_default) || drgs[0];

                            const remainingDrgs = drgs.filter(
                              (drg) => drg !== defaultDrg && drg.drg_code,
                            );

                            if (!drgs?.length) return "-";

                            const selectedIndex = getSelectedDrgIndex(
                              HimTableItem.hcp_line_id,
                            );
                            const selectedDrg = drgs[selectedIndex];

                            return (
                              <>
                                <Tooltip
                                  title={
                                    <>
                                      <div>
                                        <b>Grouper Version:</b>{" "}
                                        {defaultDrg.grouper_version}
                                      </div>
                                      <div>
                                        <b>Weight:</b> {defaultDrg.weight}
                                      </div>
                                    </>
                                  }
                                  arrow
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      fontWeight: 500,
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: "2px",
                                    }}
                                    onClick={(e) =>
                                      openDrgMenu(e, HimTableItem.hcp_line_id)
                                    }
                                  >
                                    {defaultDrg.drg_code}
                                    {drgs?.length > 1 && (
                                      <ArrowDropDownIcon fontSize="small" />
                                    )}
                                  </span>
                                </Tooltip>

                                <Menu
                                  anchorEl={drgAnchorEl}
                                  open={
                                    Boolean(drgAnchorEl) &&
                                    activeDrgRow === HimTableItem.hcp_line_id
                                  }
                                  onClose={closeDrgMenu}
                                >
                                  {remainingDrgs.map((drg, index) => (
                                    <Tooltip
                                      key={index}
                                      title={
                                        <>
                                          <div>
                                            <b>Version:</b>{" "}
                                            {drg.grouper_version}
                                          </div>
                                          <div>
                                            <b>Weight:</b> {drg.weight}
                                          </div>
                                        </>
                                      }
                                      placement="right"
                                      arrow
                                    >
                                      <MenuItem
                                        onClick={() => {
                                          updateSelectedDrgIndex(
                                            HimTableItem.hcp_line_id,
                                            index,
                                          );
                                          closeDrgMenu();
                                        }}
                                      >
                                        {drg.drg_code}
                                      </MenuItem>
                                    </Tooltip>
                                  ))}
                                </Menu>
                              </>
                            );
                          })()}
                        </td>
                        <td className="workflow-him-table-td">
                          {(() => {
                            const drgs = HimTableItem?.drg_code || [];
                            if (!drgs.length) return "-";

                            const defaultDrg =
                              drgs.find((drg) => drg.is_default) || drgs[0];

                            if (!drgs?.length) return "-";

                            return (
                              <>
                                <span>
                                  ${" "}
                                  {Math.round(
                                    defaultDrg.weight * 7258,
                                  ).toLocaleString()}
                                </span>
                              </>
                            );
                          })()}
                        </td>
                        {/* <td className="workflow-him-table-td">
                      {!isNaN(Number(HimTableItem?.weight))
                        ? Number(HimTableItem?.weight)?.toFixed(4)
                        : "-"}
                    </td> */}
                        {/* <td className="workflow-him-table-td">
                        {Number.isFinite(HimTableItem?.weight)
                          ? Math.round(
                              HimTableItem?.weight * 7258
                            )?.toLocaleString("en-IN")
                          : "-"}
                      </td> */}
                        {/* <td className="workflow-him-table-td">
                      <Badge className="workflow-him-current_queue">
                        <div>
                          <img
                            src={userIcon}
                            alt=""
                            height="15px"
                            width="15px"
                            className="me-2"
                          />
                        </div>
                        <div>{HimTableItem?.queue[0].queue_name}</div>
                        <div></div>
                      </Badge>
                    </td> */}
                        {/* <td className="workflow-him-table-td">
                        {HimTableItem?.queue?.length > 0 ? (
                          <> */}
                        {/* <div>
                              <img
                                src={userIcon}
                                alt=""
                                height="15px"
                                width="15px"
                                className="me-2"
                              />
                            </div> */}
                        {/* <div>
                              {HimTableItem.queue
                                .filter(q => q.queue_name)
                                .map(q => q.queue_name)
                                .join(', ')}
                            </div>
                            </>
                        ) : " - "}
                    </td> */}

                        <td className="workflow-him-table-td">
                          {HimTableItem?.queue?.length > 0
                            ? (() => {
                                const queueNames = HimTableItem.queue
                                  .filter((q) => q?.queue_name)
                                  .map((q) => q.queue_name);

                                const MAX_ITEMS = 2;
                                const visibleItems = queueNames.slice(
                                  0,
                                  MAX_ITEMS,
                                );
                                const hasMore = queueNames.length > MAX_ITEMS;

                                return (
                                  <Tooltip
                                    title={
                                      <div style={{ padding: "4px 8px" }}>
                                        {queueNames.map((name, index) => (
                                          <div key={index}> {name}</div>
                                        ))}
                                      </div>
                                    }
                                    arrow
                                    placement="top"
                                  >
                                    <div
                                      style={{
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "180px",
                                      }}
                                    >
                                      {visibleItems.map((name, index) => (
                                        <span key={index}>
                                          {name}
                                          {index < visibleItems.length - 1 &&
                                            ", "}
                                        </span>
                                      ))}
                                      {hasMore && " ..."}
                                    </div>
                                  </Tooltip>
                                );
                              })()
                            : "-"}
                        </td>

                        <td className="workflow-him-table-td">
                          {HimTableItem?.priority?.length > 0 ? (
                            <Badge
                              className="workflow-him-priority"
                              bg={null}
                              style={{
                                backgroundColor: styles.bg,
                                border: `1px solid ${styles.border}`,
                                color: styles.color,
                                padding: "5px 10px",
                                borderRadius: "12px",
                                fontSize: "12px",
                              }}
                            >
                              {activePriority === "NIL ASSIGNED"
                                ? ""
                                : activePriority || "-"}
                            </Badge>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td className="workflow-auditor-table-td">
                          {Array.isArray(HimTableItem?.status) &&
                          HimTableItem.status.length > 0
                            ? (() => {
                                const list = HimTableItem.status.filter(
                                  (s) => s?.status,
                                );
                                const topStatus = list?.filter(
                                  (item) => item?.is_primary,
                                );
                                const statusText =
                                  topStatus?.map((item) => item.status) ?? "-";
                                const hasMultiple = list.length > 1;

                                const getColor = (statusText) => {
                                  const status = statusText[0];
                                  switch (status) {
                                    case "Audit - AI processing complete - codes available for validation":
                                      return "#4CAF50";
                                    case "Audit - Audited":
                                      return "#2E7D32";
                                    case "Audit - Awaiting Audit":
                                    case "Awaiting Audit":
                                      return "#FFA726";
                                    case "Audit - Awaiting CDQ":
                                      return "#FFB300";
                                    case "Audit - CDQ For Review":
                                      return "#FB8C00";
                                    case "Audit - Coding Complete":
                                      return "#00897B";
                                    case "Audit - Locked by user":
                                      return "#757575";
                                    case "Audit - Missing Notes":
                                      return "#E53935";
                                    case "Audit - On Hold":
                                      return "#6A1B9A";
                                    case "Audit - Outstanding":
                                      return "#F44336";
                                    default:
                                      return "#344054";
                                  }
                                };

                                return (
                                  <Tooltip
                                    title={
                                      <div style={{ padding: "4px 8px" }}>
                                        {list.map((item, index) => (
                                          <div key={index}>{item.status}</div>
                                        ))}
                                      </div>
                                    }
                                    arrow
                                    placement="top"
                                  >
                                    <Box
                                      sx={{
                                        position: "relative",
                                        width: "180px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {hasMultiple &&
                                        list.slice(1, 3).map((item, index) => (
                                          <Box
                                            key={index}
                                            sx={{
                                              position: "absolute",
                                              top: `${(index + 1) * 4}px`,
                                              left: `${(index + 1) * 4}px`,
                                              width: "100%",
                                              height: "34px",
                                              borderRadius: "6px",
                                              backgroundColor: "#E0E0E0",
                                              zIndex: index,
                                            }}
                                          />
                                        ))}

                                      <Box
                                        sx={{
                                          position: "relative",
                                          zIndex: 1,
                                          backgroundColor: "#FFF",
                                          color: getColor(statusText),
                                          border: "1px solid #D0D5DD",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          padding: "6px 8px",
                                          textAlign: "center",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          boxShadow:
                                            "0 2px 6px rgba(0,0,0,0.1)",
                                        }}
                                      >
                                        {statusText}
                                      </Box>

                                      {list.length > 3 && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            bottom: "-6px",
                                            right: "-6px",
                                            background: "#344054",
                                            color: "#fff",
                                            fontSize: "10px",
                                            borderRadius: "10px",
                                            px: "5px",
                                            py: "1px",
                                          }}
                                        >
                                          +{list.length - 1}
                                        </Box>
                                      )}
                                    </Box>
                                  </Tooltip>
                                );
                              })()
                            : "-"}
                        </td>
                        {(codebookcoblhEnv || codebookdevEnv) && (
                          <td className="workflow-him-table-td">
                            {HimTableItem?.cdq_count > 0 ? (
                              <span
                                className="workflow-him-cdq-view"
                                style={{
                                  color: "#175CD3",
                                  fontWeight: 500,
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewCdqResponses(HimTableItem);
                                }}
                              >
                                View ({HimTableItem.cdq_count})
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })
                ) : (
                  <td colspan="10">
                    <div className="workflow-coder-table-no-records">
                      No records found
                    </div>
                  </td>
                )}
              </tbody>
            </Table>
          </div>
          <div className="coderViewTable-footer">
            <div>
              <Pagination className="HimTable-pagination">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={filtersPayload?.page_number <= 1}
                />
                <Pagination.Prev
                  onClick={() =>
                    handlePageChange(filtersPayload?.page_number - 1)
                  }
                  disabled={filtersPayload?.page_number <= 1}
                  className="HimTable-prev-btn"
                />
                <Pagination.Item>
                  Page {filtersPayload?.page_number} of {totalPages}
                </Pagination.Item>
                <Pagination.Next
                  onClick={() =>
                    handlePageChange(filtersPayload?.page_number + 1)
                  }
                  disabled={filtersPayload?.page_number >= totalPages}
                  className="HimTable-next-btn"
                />
                <Pagination.Last
                  onClick={() => handlePageChange(totalPages)}
                  disabled={filtersPayload?.page_number === totalPages}
                />
              </Pagination>
            </div>
            {/* <div className="HimTable-row-options">
              <Form.Select
                className="HimTable-select"
                value={filtersPayload?.page_size}
                onChange={handleRowsPerPageChange}
              >
                <option
                  value=""
                  disabled
                  className="HimTable-rows-per-page_number"
                >
                  Rows per page
                </option>

                <option value={10} className="HimTable-rows-per-page">
                  10
                </option>
                <option value={20} className="HimTable-rows-per-page">
                  20
                </option>
                <option value={50} className="HimTable-rows-per-page">
                  50
                </option>
              </Form.Select>
            </div> */}
          </div>
        </div>
      </div>
      {preferencesLoading ? (
        <div
          className="modal fade coding-screen-popup user-preference-modal show"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content shadow"
              style={{
                width: "fit-content",
                minWidth: "420px",
                maxWidth: "500px",
                borderRadius: "12px",
                border: "none",
                overflow: "hidden",
              }}
            >
              <div
                className="modal-body d-flex flex-column justify-content-center align-items-center py-5"
                style={{
                  minHeight: "220px",
                  padding: "16px 20px",
                  maxHeight: "70vh",
                  overflowY: "auto",
                }}
              >
                <div
                  className="mb-4"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    background: "#f5f7fa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Spinner animation="border" variant="primary" />
                </div>

                <h5
                  className="mb-2"
                  style={{
                    color: "#032f49",
                    fontWeight: 600,
                  }}
                >
                  Loading Preferences
                </h5>

                <p
                  className="mb-0 text-center"
                  style={{
                    color: "#6c757d",
                    maxWidth: "320px",
                    fontSize: "14px",
                  }}
                >
                  Please wait while we fetch your preferences. This will only
                  take a moment.
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        showUserPreferenceModal && (
          <div
            className="modal fade coding-screen-popup user-preference-modal show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{
                width: "550px",
                maxWidth: "90vw",
                margin: "1.75rem auto",
              }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    aria-label="Close"
                    onClick={() => {
                      setShowUserPreferenceModal(false);
                      setQueueSelected(loginUserID);
                      setSelectedQueueIndex(null);
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  Kindly select your desired coding module
                </div>
                <div className="modal-footer mb-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    disabled={
                      showAvailableAuditQueuesLoading ||
                      !userPreferences?.["Code Assist"]
                    }
                    onClick={() => navigateToDesiredPage("assist")}
                  >
                    Code Assist
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    disabled={
                      showAvailableAuditQueuesLoading ||
                      !userPreferences?.["Code Accelerate"]
                    }
                    onClick={() => navigateToDesiredPage("accelerate")}
                  >
                    Code Accelerate
                  </button>
                </div>

                {/* Queue Buttons - Refactored Section */}
                {showAvailableAuditQueuesError?.status === 404 && (
                  <span style={{ textAlign: "center", color: "red" }}>
                    This episode is not assigned to any queue or user.
                  </span>
                )}

                {
                  // Display queues section
                  (() => {
                    // Separate queues into categories
                    const assignedQueues = clickedEpisodeQueues.filter(
                      (q) =>
                        "assigned_user_id" in q &&
                        q?.queue_id !== null &&
                        q?.queue_name?.trim(),
                    );

                    const cdqReviewQueues = clickedEpisodeQueues.filter(
                      (q) =>
                        "assigned_user_id" in q &&
                        q?.queue_id === null &&
                        !q?.queue_name?.trim(),
                    );

                    const availableQueues = clickedEpisodeQueues.filter(
                      (q) => !("assigned_user_id" in q),
                    );

                    // Check if there are any assigned queues (with queue_id and queue_name)
                    const hasAssignedQueues = assignedQueues.length > 0;

                    // Check if there are any CDQ review queues
                    const hasCdqReviewQueues = cdqReviewQueues.length > 0;

                    // Check if there are any available queues
                    const hasAvailableQueues = availableQueues.length > 0;

                    // Determine the heading for assigned queues
                    const getAssignedHeading = () => {
                      // Check if all assigned queues are assigned to the current user
                      const allAssignedToUser = assignedQueues.every(
                        (q) => q.assigned_user_id === queueSelected,
                      );

                      // Check if any assigned queue is assigned to the current user
                      const someAssignedToUser = assignedQueues.some(
                        (q) => q.assigned_user_id === queueSelected,
                      );

                      if (allAssignedToUser) {
                        return "Assigned to You";
                      } else if (someAssignedToUser) {
                        return "Assigned to Team";
                      } else {
                        return "Assigned to Others";
                      }
                    };

                    return (
                      <div>
                        {showAvailableAuditQueuesLoading ? (
                          <div
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            Loading queues...
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "12px",
                              padding: "12px 16px",
                            }}
                          >
                            {/* ================= ASSIGNED QUEUES SECTION ================= */}
                            {hasAssignedQueues && (
                              <>
                                <strong
                                  style={{
                                    fontSize: "16px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  {getAssignedHeading()}
                                </strong>

                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    justifyContent: "center",
                                    width: "100%",
                                    overflow: "auto",
                                    maxHeight: "45vh",
                                  }}
                                >
                                  {assignedQueues.map((queue, index) => {
                                    const originalIndex =
                                      clickedEpisodeQueues.indexOf(queue);
                                    // Use line_assignment_id for comparison if available, otherwise use queue_id or assigned_username
                                    const isSelected =
                                      (queue.line_assignment_id &&
                                        selectedQueue?.line_assignment_id ===
                                          queue.line_assignment_id) ||
                                      (!queue.line_assignment_id &&
                                        selectedQueue?.queue_id ===
                                          queue.queue_id) ||
                                      selectedQueueIndex === originalIndex;

                                    return (
                                      <button
                                        key={
                                          queue.assigned_username ||
                                          queue.queue_id
                                        }
                                        type="button"
                                        style={{
                                          flex: "1 1 calc(50% - 12px)",
                                          minWidth: "120px",
                                          maxWidth: "calc(50% - 12px)",
                                          padding: "8px",
                                          borderRadius: "8px",
                                          border: `2px solid ${
                                            isSelected ? "#032f49" : "#e0e0e0"
                                          }`,
                                          backgroundColor: isSelected
                                            ? "#032f49"
                                            : "#fff",
                                          color: isSelected ? "#fff" : "#333",
                                          cursor: "pointer",
                                          textAlign: "left",
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "4px",
                                          transition: "all 0.2s ease",
                                        }}
                                        onClick={() => {
                                          const idx =
                                            clickedEpisodeQueues.indexOf(
                                              queue,
                                            );
                                          handleQueueSelect(queue, idx);
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {queue.assigned_username ||
                                            queue.queue_name}
                                        </span>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            opacity: 0.75,
                                          }}
                                        >
                                          {queue.assignment_reason
                                            ? `Reason: ${queue.assignment_reason}`
                                            : "No reason provided"}
                                        </span>
                                      </button>
                                    );
                                  })}
                                </div>
                              </>
                            )}

                            {/* ================= CDQ REVIEW REQUIRED SECTION ================= */}
                            {hasCdqReviewQueues && (
                              <>
                                <strong
                                  style={{
                                    fontSize: "16px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  CDQ Review Required
                                </strong>

                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    justifyContent: "center",
                                    width: "100%",
                                    overflow: "auto",
                                    maxHeight: "45vh",
                                  }}
                                >
                                  {cdqReviewQueues.map((queue, index) => {
                                    const originalIndex =
                                      clickedEpisodeQueues.indexOf(queue);
                                    // Use line_assignment_id for comparison
                                    const isSelected =
                                      (queue.line_assignment_id &&
                                        selectedQueue?.line_assignment_id ===
                                          queue.line_assignment_id) ||
                                      selectedQueueIndex === originalIndex;

                                    return (
                                      <button
                                        key={queue.assigned_username}
                                        type="button"
                                        style={{
                                          flex: "1 1 calc(50% - 12px)",
                                          minWidth: "120px",
                                          maxWidth: "calc(50% - 12px)",
                                          padding: "8px",
                                          borderRadius: "8px",
                                          border: `2px solid ${
                                            isSelected ? "#032f49" : "#e0e0e0"
                                          }`,
                                          backgroundColor: isSelected
                                            ? "#032f49"
                                            : "#fff",
                                          color: isSelected ? "#fff" : "#333",
                                          cursor: "pointer",
                                          textAlign: "left",
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "4px",
                                          transition: "all 0.2s ease",
                                        }}
                                        onClick={() => {
                                          const idx =
                                            clickedEpisodeQueues.indexOf(
                                              queue,
                                            );
                                          handleQueueSelect(queue, idx);
                                        }}
                                      >
                                        <span
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {queue.assigned_username}
                                        </span>
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            opacity: 0.75,
                                          }}
                                        >
                                          {queue.assignment_reason
                                            ? `Reason: ${queue.assignment_reason}`
                                            : "No reason provided"}
                                        </span>
                                      </button>
                                    );
                                  })}
                                </div>
                              </>
                            )}

                            {/* ================= AVAILABLE CODER QUEUES SECTION ================= */}
                            {hasAvailableQueues && (
                              <>
                                <strong
                                  style={{
                                    fontSize: "16px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  Available Coder Queues:
                                </strong>

                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    justifyContent: "center",
                                    width: "100%",
                                  }}
                                >
                                  {availableQueues.map((queue, index) => {
                                    const originalIndex =
                                      clickedEpisodeQueues.indexOf(queue);
                                    // For available queues, use queue_id for comparison
                                    const isSelected =
                                      selectedQueue?.queue_id ===
                                        queue.queue_id ||
                                      selectedQueueIndex === originalIndex;

                                    return (
                                      <button
                                        key={queue.queue_id}
                                        type="button"
                                        style={{
                                          flex: "1 1 calc(50% - 12px)",
                                          minWidth: "120px",
                                          maxWidth: "calc(50% - 12px)",
                                          padding: "6px 8px",
                                          borderRadius: "6px",
                                          border: `2px solid ${
                                            isSelected ? "#032f49" : "#dee2e6"
                                          }`,
                                          backgroundColor: isSelected
                                            ? "#032f49"
                                            : "transparent",
                                          color: isSelected
                                            ? "white"
                                            : "#212529",
                                          fontWeight: "500",
                                          cursor: "pointer",
                                          fontSize: "14px",
                                          textAlign: "center",
                                          transition: "all 0.2s ease",
                                          height: "48px",
                                          boxSizing: "border-box",
                                        }}
                                        onClick={() => {
                                          const idx =
                                            clickedEpisodeQueues.indexOf(
                                              queue,
                                            );
                                          handleQueueSelect(queue, idx);
                                        }}
                                      >
                                        {queue.queue_name}
                                      </button>
                                    );
                                  })}
                                </div>
                              </>
                            )}

                            {/* Show message if no queues at all */}
                            {!hasAssignedQueues &&
                              !hasCdqReviewQueues &&
                              !hasAvailableQueues && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    color: "#666",
                                  }}
                                >
                                  No queues available for this episode.
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    );
                  })()
                }
              </div>
            </div>
          </div>
        )
      )}
      {workflowHimsAssginModal && (
        <HealthInformationManagerAssignModal
          workflowHimsAssginModal={workflowHimsAssginModal}
          setWorkflowHimsAssginModal={setWorkflowHimsAssginModal}
          selectedRecord={selectedRecord}
          isAllEpisodesSelected={isAllEpisodesSelected}
        />
      )}
      <CoderFilterModal
        losValue={losValue}
        setLosValue={setLosValue}
        losOperator={losOperator}
        setLosOperator={setLosOperator}
        show={showCoderFilter}
        setShowCoderFilter={setShowCoderFilter}
        isLosEnabled={isLosEnabled}
        setIsLosEnabled={setIsLosEnabled}
        onClose={handleModalClose}
        setCoderSearchTerm={setCoderSearchTerm}
      />
      <CdqResponseHistoryModal
        show={showCdqModal}
        onClose={handleCloseCdqModal}
        loading={loadingCdqHistoryData}
        error={errorCdqHistoryData}
        episodeIdentifier={selectedCdqRecord?.episode_identifier}
         totalCount={cdqHistoryData?.count_cdq_response}
          currentPage={cdqPageNumber}
          onPageChange={handleCdqPageChange}
        // onLoadMore={handleLoadMoreCdqResponses}
         responses={cdqHistoryData?.cdq_responses || []}
      />
    </div>
  );
};

export default CoderView;